/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import DoneIcon from '@material-ui/icons/Done';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import ordersActionCreators from '../../State/Store/Orders/Orders.actions';
import orderConfirmationDoneSelector from '../../State/Store/Orders/Selectors/OrderConfirmationDone.selector';
import orderConfirmedSelector from '../../State/Store/Orders/Selectors/OrderConfirmed.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderConfirmationDialog from '../OrderConfirmationDialog/OrderConfirmationDialog.component';
import OrderConfirmationButtonPropTypes from './OrderConfirmationButton.component.props';
import orderConfirmationButtonStyles from './OrderConfirmationButton.component.styles';

/**
 * OrderConfirmationButtonComponent
 * @export
 * @class OrderConfirmationButtonComponent
 * @extends {React.Component<OrderConfirmationButtonComponentComposedProps, OrderConfirmationButtonComponentState>}
 */
export class OrderConfirmationButtonComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConfirmationButtonComponentProps>}
   * @memberof OrderConfirmationButtonComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConfirmationButton`}
   * @memberof OrderConfirmationButtonComponent
   */
  static displayName = `OrderConfirmationButton`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConfirmationButtonComponent
   */
  static propTypes = OrderConfirmationButtonPropTypes;

  /**
   * handleClickOpen
   * @returns {void} void
   * @memberof OrderConfirmationButtonComponent
   */
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  /**
   * handleClickClose
   * @returns {void} void
   * @memberof OrderConfirmationButtonComponent
   */
  handleClickClose = () => {
    this.setState({ open: false });
  };

  /**
   * Data specific to the `<OrderConfirmationButtonComponent />` instance
   * @type {OrderConfirmationButtonComponentState}
   * @memberof OrderConfirmationButtonComponent
   */
  state = {
    open: false,
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConfirmationButtonComponent />`
   * @memberof OrderConfirmationButtonComponent
   */
  render() {
    const { classes, details, orderConfirmed, summary, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    const { open } = this.state;
    return (
      !orderConfirmed && (
        <React.Fragment>
          <Button className={classes.confirmation} fullWidth={isSmall || isLarge} onClick={this.handleClickOpen} variant="contained">
            <Grid container justify="space-between">
              <I18n className={classes.textAlignLeft} textTransform="none" variant="subtitle1">
                OrderService.ConfirmationOrderButtonLabel
              </I18n>
            </Grid>
            <DoneIcon className={classes.tick} />
          </Button>
          <OrderConfirmationDialog details={details} i18nSection="OrderConfirmation" onYesClick={this.handleClickClose} open={open} summary={summary} />
        </React.Fragment>
      )
    );
  }
}

/** @type {React.ComponentClass<OrderConfirmationButtonComponentProps>} */
const OrderConfirmationButton = compose(
  withServices,
  withRouter,
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderConfirmationButtonStyles), { withTheme: true }),
  connect(
    (state) => {
      return {
        orderConfirmationDone: orderConfirmationDoneSelector(state),
        orderConfirmed: orderConfirmedSelector(state),
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...ordersActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderConfirmationButtonComponent);

export default OrderConfirmationButton;
